<template>
  <div class="table">
    <v-data-table
      :headers="headers"
      :items="items"
      :hide-default-footer="true"
      no-data-text="Aucun élément ajouté"
      :items-per-page="15"
    >
      <template v-slot:top>
        <v-dialog
          :value="dialog"
          @click:outside="closeDialog"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="validSubform" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-text-field
                        dense
                        outlined
                        label="Description *"
                        required
                        :rules="validation.description"
                        @input="
                          (value) => {
                            updateCurrentItem({
                              fieldname: 'description',
                              value,
                            });
                          }
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-text-field
                        dense
                        outlined
                        label="Quantité"
                        type="number"
                        @input="
                          (value) => {
                            updateCurrentItem({
                              fieldname: 'quantity',
                              value,
                            });
                          }
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-text-field
                        dense
                        outlined
                        label="N° Article, code, numéro, dimensions"
                        @input="
                          (value) => {
                            updateCurrentItem({
                              fieldname: 'serial',
                              value,
                            });
                          }
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialog"
                >Annuler</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :disabled="!validSubform"
                >Sauver</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.actions="{ item }" v-if="!readOnly">
        <v-icon
          small
          class="mr-2"
          @click="edit(item)"
          :disabled="status && status !== 'draft'"
          >mdi-pencil</v-icon
        >
        <v-icon
          small
          @click="removeItem(item)"
          :disabled="status && status !== 'draft'"
          >mdi-delete</v-icon
        >
      </template>
    </v-data-table>
    <v-divider />
    <v-btn
      class="my-1"
      color="grey darken-3"
      text
      @click="openDialog"
      v-if="items.length < 15"
      :disabled="status && status !== 'draft'"
      >Ajouter un élément</v-btn
    >
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["readOnly"],
  data: () => ({
    validSubform: false,
    validation: {
      description: [(value) => !!value || "Ce champ est requis."],
    },
    headers: [
      {
        text: "Description",
        align: "start",
        sortable: false,
        value: "description",
      },
      {
        text: "Quantité",
        align: "start",
        sortable: false,
        value: "quantity",
      },
      {
        text: "N° Article, code, numéro, dimensions",
        align: "start",
        sortable: false,
        value: "serial",
      },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState({
      items: (state) => state.orders.current.items,
      status: (state) => state.orders.current.status,
      editedItem: (state) => state.orders.editedItem,
      editedIndex: (state) => state.orders.editedIndex,
      dialog: (state) => state.orders.dialog,
    }),
    formTitle() {
      return this.editedIndex === -1
        ? "Ajouter un élément"
        : "Éditer un élément";
    },
  },

  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },

  methods: {
    ...mapActions("orders", [
      "addItem",
      "updateItem",
      "deleteItem",
      "editItem",
      "openDialog",
      "closeDialog",
      "updateCurrentItem",
    ]),
    edit(item) {
      this.editItem(item);
    },

    removeItem(item) {
      const index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.deleteItem(index);
    },

    save() {
      console.log(this.editedIndex);
      if (this.editedIndex > -1) {
        this.updateItem({ index: this.editedIndex, item: this.editedItem });
      } else {
        this.addItem(this.editedItem);
      }
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.table {
  border: solid 1px rgba(0, 0, 0, 0.38);
  border-radius: 5px;
}
</style>